function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "People_svg__4_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E9F6FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#E8FFF3"
})), React.createElement("linearGradient", {
  id: "People_svg__5_b",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#8FD2FF",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#73D4A2",
  stopOpacity: 0.2
})), React.createElement("linearGradient", {
  id: "People_svg__6_c",
  x1: "0%",
  x2: "98.306%",
  y1: "0%",
  y2: "98.306%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#98D5FD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#4EDC9F"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#People_svg__4_a)",
  stroke: "url(#People_svg__5_b)",
  d: "M8 .5A7.5 7.5 0 00.5 8v34A7.5 7.5 0 008 49.5h34a7.5 7.5 0 007.5-7.5V8A7.5 7.5 0 0042 .5H8z"
}), React.createElement("path", {
  fill: "url(#People_svg__6_c)",
  d: "M25 12c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13a13 13 0 00-13-13zm5.318 8.273c1.605 0 2.917 1.296 2.955 2.92 0 1.65-1.323 2.989-2.955 2.989-1.632 0-2.954-1.339-2.954-2.99.037-1.623 1.349-2.92 2.954-2.92zm-14.773 3.545c.04-2.647 2.155-4.762 4.728-4.727 2.567-.021 4.673 2.086 4.727 4.727-.047 2.645-2.158 4.755-4.727 4.727-2.57.028-4.68-2.082-4.728-4.727zm.58 6.701a6.795 6.795 0 014.148-1.182c4.053 0 6.098 2.66 7.09 5.91-.776.169-1.568.252-2.363.248-3.607-.003-6.96-1.92-8.875-4.976zm12.68 4.196a12.338 12.338 0 00-1.37-2.86 8.828 8.828 0 00-1.832-2.104 5.295 5.295 0 014.869-2.73 5.354 5.354 0 014.254 1.844 10.636 10.636 0 01-5.92 5.909v-.06z"
}));

var SvgPeople = function SvgPeople(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgPeople;